import { Controller } from "@hotwired/stimulus"

// Handles expand/collapse and inline editing for task notes
export default class extends Controller {
  static targets = ["preview", "editor", "textarea", "form"]
  static values = { expanded: Boolean }

  connect() {
    this.expandedValue = false
  }

  toggle(event) {
    event.preventDefault()
    this.expandedValue = !this.expandedValue
    this.updateVisibility()
    if (this.expandedValue && this.hasTextareaTarget) {
      this.textareaTarget.focus()
    }
  }

  expand(event) {
    event.preventDefault()
    this.expandedValue = true
    this.updateVisibility()
    if (this.hasTextareaTarget) {
      this.textareaTarget.focus()
    }
  }

  collapse() {
    this.expandedValue = false
    this.updateVisibility()
  }

  updateVisibility() {
    if (this.hasPreviewTarget) {
      this.previewTarget.classList.toggle("hidden", this.expandedValue)
    }
    if (this.hasEditorTarget) {
      this.editorTarget.classList.toggle("hidden", !this.expandedValue)
    }
  }

  cancel(event) {
    if (event.key === "Escape") {
      this.collapse()
    }
  }

  save(event) {
    event.preventDefault()
    this.formTarget.requestSubmit()
  }
}
